<rt-sidebar-item
  [icon]="icon"
  [iconActive]="!isSidebarMinimized"
  [name]="heading"
  [leftSlot]="isSidebarMinimized ? toggleIcon : undefined"
  [rightSlot]="toggleIcon"
  [type]="ItemType.Heading"
  [hoverable]="false"
  (click)="onHeaderClick()"
  [attr.border-top]="!isFirst ? true : null"
  class="heading sidebar-label sidebar-group-heading"
/>

<div class="group" [@collapse]="groupVisibilityState">
  <ng-content select="rt-sidebar-item" />
  @for (item of items; track trackByName($index, item)) {
    <ng-container *ngTemplateOutlet="walkthroughStepTemplate" />
    <rt-sidebar-item
      [name]="item.name"
      [href]="item.url"
      [rightSlot]="item.rightSlot!"
      [rightSlotContext]="item.rightSlotContext!"
      [type]="ItemType.Item"
    />
  }
</div>

<ng-template #toggleIcon>
  @if (!isSidebarMinimized && rightSlot) {
    <ng-container *ngTemplateOutlet="rightSlot" />
  }
  <rt-icon [name]="isGroupMinimized ? 'expand-more' : 'expand-less'" />
</ng-template>
